const login = r => require(['views/login'], r);
const home = r => require(['views/home'], r);
const historySearch = r => require(['views/history_search'], r);
const monitorEarthSound = r => require(['views/monitor-earth-sound'], r);
const NotFound = r => require(['views/notfound'], r);
const stress = r => require(['views/stress'], r);
const historyGeophony = r => require(['views/history_geophony'], r);
const resistance = r => require(['views/resistance'], r);
const history3d = r => require(['views/history3d'], r);
const profile = r => require(['views/profile'], r);

const manageIndex = r => require(['views/manage/manage_index'], r);
const traversePointManage = r => require(['views/manage/traverse_point_manage'], r);
const faceManage = r => require(['views/manage/face_manage'], r);
const foottageManage = r => require(['views/manage/foottage_manage'], r);
const ct_manage = r => require(['views/manage/ct_manage'], r);
const common_hole_manage = r => require(['views/manage/common_hole_manage'], r);
const tagManage = r => require(['views/manage/tag_manage'], r);
const coalProfileManage = r => require(['views/manage/coal_profile_manage'], r);
const userManage = r => require(['views/manage/user_manage'], r);
const organizationManage = r => require(['views/manage/organization_manage'], r);
const collieryManage = r => require(['views/manage/colliery_manage'], r);
const dayReport= r => require(['views/day-report'], r);
const appMap= r => require(['views/appMap'], r);

const screen = r => require(['views/screen'], r);
const historyRadiation = r => require(['views/history_radiation'], r);

const geological = r => require(['views/geological'], r);

const reportQuake = r => require(['views/report/reportQuake'], r);
const reportStrainEnergy = r => require(['views/report/reportStrainEnergy'], r);
const reportCT= r => require(['views/report/reportCT'], r);
const reportStress= r => require(['views/report/reprotStress'], r);
const reportBar= r => require(['views/report/reprotStresBar'], r);
const reportRate= r => require(['views/report/reprotStresRate'], r);
const historyBank= r => require(['views/historyBank'], r);
const cRoot= r => require(['views/hydraulic_pressure/c-root'], r);
const anchor = r => require(['views/hydraulic_pressure/anchor'], r);
/*
const restrict = r => require(['views/restrict'], r);*/
const hydraulicSupport = r => require(['views/hydraulic_pressure/hydraulic_support'], r);

const ctMap = r => require(['views/snap/ctMap'], r);
const quakeMap = r => require(['views/snap/quakeMap'], r);
const strainEnergyMap = r => require(['views/snap/strainEnergyMap'], r);
const stressMap = r => require(['views/snap/stressMap'], r);
const subsidenceMap = r=> require(['views/snap/subsidenceMap'], r);
const resistanceCloudMap = r=> require(['views/snap/resistanceCloudMap'], r);
const snapResistance = r=> require(['views/snap/Resistance'], r);
const stressRate = r=> require(['views/snap/stressRate'], r);
const quakeAnalysis = r=> require(['views/snap/quakeAnalysis'], r);

const fileList = r=> require(['views/reportForms/files-list'], r);
const reportColliery = r=> require(['views/reportForms/report-colliery'], r);
const reportFace = r=> require(['views/reportForms/report-face'], r);

// 根目录
const rootPath = '';
// 页面路由
const routes = [
    {path: '/anchor', component: anchor, name: 'anchor'},
    /*{path: '/restrict', component: restrict, name: 'restrict'},*/
    {path: '/hydraulicSupport', component: hydraulicSupport, name: 'hydraulicSupport'},
    {path: '/cRoot', component: cRoot, name: 'cRoot'},
    {path: '/geological', component: geological, name: 'geological'},
    {path: '/historyRadiation', component: historyRadiation, name: 'historyRadiation'},
    {path: '/chart/quake/scatter', component: reportQuake, name: 'reportQuake'},
    {path: '/chart/strain-energy/cloud', component: reportStrainEnergy, name: 'reportStrainEnergy'},
    {path: '/chart/ct/cloud', component: reportCT, name: 'reportCT'},
    {path: '/chart/stress/cloud', component: reportStress, name: 'reportStress'},
    {path: '/chart/stress/bar', component: reportBar, name: 'reportBar'},
    {path: '/chart/stress/rate', component: reportRate, name: 'reportRate'},
    {path: '/chart/appMap', component: appMap, name: 'appMap'},


    {path: '/snap/quakeAnalysis', component: quakeAnalysis, name: 'quakeAnalysis'},
    {path: '/snap/stressRate', component: stressRate, name: 'stressRate'},
    {path: '/snap/snapResistance', component: snapResistance, name: 'snapResistance'},
    {path: '/snap/ctMap', component: ctMap, name: 'ctMap'},
    {path: '/snap/quakeMap', component: quakeMap, name: 'quakeMap'},
    {path: '/snap/strainEnergyMap', component: strainEnergyMap, name: 'strainEnergyMap'},
    {path: '/snap/stressMap', component: stressMap, name: 'stressMap'},
    {path: '/snap/subsidenceMap', component: subsidenceMap, name: 'subsidenceMap'},
    {path: '/snap/resistanceCloudMap', component: resistanceCloudMap, name: 'resistanceCloudMap'},

    {path: '', redirect: {name: 'login'}},
    {path: '/historyBank', component: historyBank, name: 'historyBank'},
    {path: '/screen', component: screen, name: 'screen'},
    {path: '/dayReport', component: dayReport, name: 'dayReport'},
    {path: '/historyGeophony', component: historyGeophony, name: 'historyGeophony'},
    {path: '/login', component: login, name: 'login'},
    {path: '/historySearch', component: historySearch, name: 'historySearch'},
    {path: '/monitorEarthSound', component: monitorEarthSound, name: 'monitorEarthSound'},
    {path: '/history3d', component: history3d, name: 'history3d'},
    {path: '/stress', component: stress, name: 'stress'},
    {path: '/home', component: home, name: 'home'},
    {path: '/resistance', component: resistance, name: 'resistance'},

    {path: '/profile', component: profile, name: 'profile'},
    {path: '/manageIndex', component: manageIndex, name: 'manageIndex'},
    {path: '/traversePointManage', component: traversePointManage, name: 'traversePointManage'},
    {path: '/faceManage', component: faceManage, name: 'faceManage'},
    {path: '/foottageManage', component: foottageManage, name: 'foottageManage'},
    {path: '/ct_manage', component: ct_manage, name: 'ct_manage'},
    {path: '/common_hole_manage', component: common_hole_manage, name: 'common_hole_manage'},
    {path: '/tagManage', component: tagManage, name: 'tagManage'},
    {path: '/userManage', component: userManage, name: 'userManage'},
    {path: '/coalProfileManage', component: coalProfileManage, name: 'coalProfileManage'},
    {path: '/organizationManage', component: organizationManage, name: 'organizationManage'},
    {path: '/collieryManage', component: collieryManage, name: 'collieryManage'},
    
    {path: '/fileList', component: fileList, name: 'fileList'},
    {path: '/reportColliery', component: reportColliery, name: 'reportColliery'},
    {path: '/reportFace', component: reportFace, name: 'reportFace'},

].map(route => {
    route.path = rootPath + route.path;
    return route;
});

// 404 页
routes.push({path: '*', component: NotFound, name: 'notfound'});

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js